/**
 * Computes a due date from a creation timestamp and the org's standard recording time.
 */ export function computeDueDate(createdAtMs, standardRecordingTimeHours) {
    return createdAtMs + standardRecordingTimeHours * 60 * 60 * 1000;
}
/**
 * Determines urgency level based on proximity to or past the due date.
 * Thresholds scale with the allotted time (standardRecordingTimeMs).
 */ export function getDueDateUrgency(dueDateMs, standardRecordingTimeMs, nowMs = Date.now()) {
    const timeRemaining = dueDateMs - nowMs;
    if (timeRemaining > standardRecordingTimeMs * 0.25) return 'normal';
    if (timeRemaining > 0) return 'warning';
    if (-timeRemaining < standardRecordingTimeMs * 0.5) return 'overdue';
    return 'critical';
}

//# sourceMappingURL=due-date.js.map